export const usernameandnameRegex = /^[a-zA-Z0-9]+$/;
export const emailRegex =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;